import React from 'react';
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from '@chakra-ui/react';
import EditComment from '../feed/EditComment';

export default function EditCommentModal({
  isOpen,
  onClose,
  comment = null,
  onSuccess = (comment) => {},
}) {
  if (!isOpen) return null;

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent
          w={{ base: '90%', md: '500px' }}
          maxW={{ base: '90%', md: '500px' }}
          maxH="90vh"
          overflow="hidden"
        >
          <ModalBody p={4}>
            <Flex flexDirection="column">
              <EditComment
                onClose={onClose}
                comment={comment}
                onEditComment={onSuccess}
              />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
